<template>
  <div class="phone" :class="'stage_' + stage">
<!--    <div class="btn">-->
<!--      <img src="../assets/download-btn.png" @click="download">-->
<!--    </div>-->
<!--    <img class="qq-qrcode" @click="jumpQQ" src="../assets/qq-qrcode-m.png">-->
<!--    <img class="mini-app" src="../assets/mini-app-code_m.png">-->
<!--    <img class="award-qrcode" src="../assets/award-qr-code-m.png" alt="">-->
<!--    <a class="pay-center" href="https://ipay.ztgame.com/?game_id=5286"></a>-->
<!--    <div class="logo">-->
<!--      <img src="../assets/logo.png">-->
<!--    </div>-->
<!--    <a class="yuyue-btn" @click="onClickLink('yuyue')"></a>
    <div class="btns">
      <a @click="onClickRule"></a>
      <a @click="onClickLink('pay')"></a>
    </div>-->
    <div class="logo"></div>
    <div class="bottom-tips"></div>
    <div class="link-head">
      <a class="qq" @click="jumpQQ"></a>
      <a class="tieba" @click="showCodePop('tieba')"></a>
    </div>
    <div class="slogan"></div>
    <template v-if="stage === 'yuyue'">
      <a class="yuyue-btn" @click="onClickLink('yuyue')"></a>
      <div class="btns">
        <a @click="onClickRule"></a>
        <a @click="onClickLink('pay')"></a>
      </div>
    </template>
    <template v-else-if="stage === 'huaner'">
      <a class="huaner-btn" @click="onClickLink('huaner')"></a>
      <div class="btns">
        <a @click="onClickRule"></a>
        <a @click="onClickLink('pay')"></a>
      </div>
    </template>
    <template v-else>
      <div class="download-btn" @click="download"></div>
      <div class="guide-btn" @click="onClickGuide"></div>
      <div class="link-center">
        <img class="qr-code" src="../assets/golden-qr-code.png" alt="">
        <a class="rule" @click="onClickRule"></a>
        <a class="version" @click="onClickVersion"></a>
        <!--      <a class="douyin" @click="showCodePop('douyin')"></a>-->

        <a @click="onClickLink('pay')" class="pay"></a>
      </div>
    </template>
    <div class="qq-modal" v-if="qqGroupModalVisible" @click="hideModal">
      <div class="modal-content">
        <div class="copy" @click.stop="copyQQ"></div>
      </div>
    </div>
    <div v-if="codePopVisible" class="qrcode-modal">
      <div class="content">
        <div class="tips"></div>
        <img :src="qrCodeImg" alt="">
        <div class="close" @click="codePopVisible = false"></div>
      </div>
    </div>
    <transition name="fade">
      <div class="popup-wrapper" v-if="rulePopupVisible" @click.self="rulePopupVisible = false">
        <div class="rule-popup popup">
          <img class="popup-title" src="../assets/popup-title_rule.png">
          <div class="ctx">
            1）预下载开启时间：<span style="color: #b90000">1月29日19：00</span><br>
            2）测试类型：付费删档<br>
            3）测试版本：安卓/iOS，推荐雷电模拟器，点击 <a @click="onClickLink('ldmnq')">下载雷电模拟器</a><br>
            4）设备要求：<br>
            <h2>>>>推荐配置：</h2>
            iOS-A11处理器、内存2G及以上配置设备（iPhone 8p/iPhone X及以上）<br>
            安卓-高通骁龙768G/麒麟820E/天玑900/Exynos 9820及以上、内存6g及以上设备<br>
            <h2>>>>最低配置：</h2>
            iOS-A9处理器、内存2G及以上配置设备（iPhone 6s及以上）<br>
            安卓-高通骁龙460/麒麟710及以上、内存4g及以上设备<br>
            <!-- 5）预约/家族组队备战：<br>
            >>>参与烽启测试预约，即可在开测后获得6888黄金；<br>
            >>>特别注意：本次烽启测试取消预约/随机落州。开测后，主公进游戏可自主选择国家。<br>
            【活动传送门】<a @click="onClickLink('csm')">https://zt-g.cn/a2rtcb5</a><br> -->
            5）充值返利规则：<br>
            1、同一账号在删档测试期间充值的黄金直充和赠送他人的月卡，我们将在下次删档测试重新发送给该账号（包括赠送的黄金、绑定黄金、再次送出的月卡资格）。<br>
            直充黄金<br>
            >>如果玩家的游戏账号在不删档测试中，进行了黄金直充，该账号将在随后每次不删档测试中获得该直充同数量的黄金和绑定黄金。<br>
            >>通过【开服活动】中的【充值返利】，可以查看后续测试返还的直充黄金和绑定黄金返还数量。<br>
            >>公测时的直充黄金返还规则，将在公测时公布。<br>
            赠送月卡<br>
            >>如果玩家的游戏账号在不删档测试中，赠送给其他玩家月卡，该账号将在随后每次不删档测试中获得同规格同数量【月卡赠送道具】。<br>
            >>在背包内使用该道具，可再次选择对象赠送月卡。<br>
            >>账号每次送出的月卡会进行累计，在公测时一次性全额返还给送出的账号。<br>
            2、同一账号在之前删档测试期间累计充值的月卡（不包含系统和其他玩家赠送的月卡），我们将在之后每次删档测试以一定比例叠加返还，不影响玩家当次测试继续充值月卡。<br>
            具体比例如下：<br>
            >>累计充值同档位月卡 1~2张，叠加返还该档位月卡 *1；<br>
            >>累计充值同档位月卡 3~4张，叠加返还该档位月卡 *2；<br>
            >>累计充值同档位月卡 5~9张，叠加返还该档位月卡 *3；<br>
            >>累计充值同档位月卡 10~15张，叠加返还该档位月卡 *4；<br>
            >>累计充值同档位月卡 16张及以上，叠加返还该档位月卡 *5；<br>
            【举例说明】<br>
            假设有一位玩家参与游戏测试，进行如下操作：<br>
            第一次删档测试<br>
            >>本次测试充值 648元月卡 *1，正常获得月卡奖励。<br>
            >>累计充值 648元月卡 *1。第二次删档测试获得 648元返利月卡*1。<br>
            第二次删档测试<br>
            >>获得第一次测试的 648元返利月卡*1。<br>
            >>本次测试充值 648元月卡 *2，正常获得月卡奖励。<br>
            >>前两次测试，累计充值648元月卡 *3。第三次删档测试获得 648元返利月卡*2。<br>
            第三次删档测试<br>
            >>获得前两次测试的 648元返利月卡*2。<br>
            >>本次测试充值 648元月卡*2，正常获得月卡奖励。<br>
            >>前三次测试，累计充值 648元月卡*5，下次测试获得648元返利月卡*3。<br>
            第四次删档测试<br>
            >>获得前三次测试的 648元返利月卡*3。<br>
            >>本次测试充值 648元月卡*5，正常获得月卡奖励。<br>
            >>前四次测试，累计充值 648元月卡*10，下次测试获得648元返利月卡*4。<br>
            第五次删档测试<br>
            >>获得前四次测试的 648元返利月卡*4。<br>
            >>未充值648元月卡。<br>
            游戏公测<br>
            >>游戏将返还前五次删档测试，累计充值的 648元月卡*10。具体返还规则将在公测时公布。
          </div>
          <div class="close" @click.self="rulePopupVisible = false"></div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="popup-wrapper" v-if="versionPopupVisible" @click.self="versionPopupVisible = false">
        <div class="version-popup popup">
          <img class="popup-title" src="../assets/popup-title_version.png">
          <div class="ctx">
            <img style="width: 100%" src="../assets/version-content.jpg" alt="">
          </div>
          <div class="close" @click.self="versionPopupVisible = false"></div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="popup-wrapper" v-if="iosGuideVisible" @click.self="iosGuideVisible = false">
        <div class="guide-popup popup">
          <img class="popup-title" src="../assets/popup-title_guide.png">
          <div class="ctx">
            <img src="../assets/ios-guide.png" alt="" class="guide">
          </div>
          <div class="close" @click.self="iosGuideVisible = false"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {getParameterByName, isAndroid, isWeiXin} from "@/tools/utils";
import tiebaPopImg from '../assets/tieba-pop.png'
import douyinPopImg from '../assets/douyin-pop.png'
export default {
  name: 'Moblie',
  data() {
    return {
      qqGroupNumber: '799259520',
      qqGroupLink: 'https://qm.qq.com/q/qlodnL2uiI',
      qqGroupModalVisible: false,
      qrCodeImg: tiebaPopImg,
      codePopVisible: false,
      rulePopupVisible: false,
      versionPopupVisible: false,
      iosGuideVisible: false,
      ztmtag: '',
      stage: 'download'
    }
  },
  methods: {
    onClickRule() {
      this.rulePopupVisible = true
      window._paq && window._paq.push(['trackEvent', '官网', '点击', '测试须知', 'mobile'])
    },
    onClickVersion() {
      this.versionPopupVisible = true
      window._paq && window._paq.push(['trackEvent', '官网', '点击', '版本内容', 'mobile'])
    },
    onClickLink(type) {
      let url = ''
      let param = ''
      switch (type) {
        case 'pay':
          url = 'https://ipay.ztgame.com/?game_id=5286'
          param = '支付中心'
          break
        case 'yuyue':
          url = 'https://zt-g.cn/a2rtcfg'
          param = '预约'
          break;
        case 'ldmnq': // 雷电模拟器
          url = 'https://www.ldmnq.com/'
          param = '雷电模拟器'
          break
        case 'csm': // 传送门
          url = 'https://zt-g.cn/a2rtcfg'
          param = '传送门'
          break
        case 'huaner': // 传送门 添加客服
            url ='https://zt-g.cn/a2rt9o1'
            param = '环儿'
          break
      }
      window._paq && window._paq.push(['trackEvent', '官网', '点击', param, 'mobile'])
      // window.open(url)
      window.location.href = url
    },
    download() {
      window._paq && window._paq.push(['trackEvent', '官网', '下载', '移动端下载', 'mobile'])
      window.open('/download/index.html' + (this.ztmtag ? '?ztmtag=' + this.ztmtag : ''))
    },
    change() {
      // var a = document.querySelector('.footer #bottom .botp1 a')
      // var p = document.querySelector('.footer #bottom .botp3')
      // var p2 = document.querySelector('.footer #bottom .botps30')
      // var p3 = document.querySelector('.footer #bottom .botp2')
      // a.href = "https://www.ztgame.com/privacy.html"
      // p.innerHTML = "互联网出版许可证：(属)网出证(沪)字第026号&nbsp;&nbsp;增值电信业务经营许可证：沪B2-20050107&nbsp;&nbsp;ISBN：978-7-89988-481-2&nbsp;&nbsp;" + `<br>`
      // p2.innerHTML = "健康游戏忠告：" + `<br>` + "抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防受骗上当，" + `<br>` + "适度游戏益脑，沉迷游戏伤身，合理安排时间，享受健康生活。" + `<br>`
      // p3.innerHTML = "适龄提示：本游戏适合18岁以上的玩家进入"
    },
    jumpQQ() {
      if (isWeiXin()) {
        window._paq && window._paq.push(['trackEvent', '官网', '点击', 'qq', 'weixin'])
        window.location.href = location.origin + location.pathname + '#/?jumpQQ=1'
        this.qqGroupModalVisible = true
      } else {
        window._paq && window._paq.push(['trackEvent', '官网', '点击', 'qq', ''])
        window.location.href = this.qqGroupLink
      }
    },
    async copyQQ() {
      window._paq && window._paq.push(['trackEvent', '官网', '点击', '复制qq', 'mobile'])
      await this.$copyText(this.qqGroupNumber);
      alert('复制成功');
    },
    hideModal() {
      window.location.href = location.origin + location.pathname + '#/'
      this.qqGroupModalVisible = false
    },
    onClickAppt() {
      window.alert('敬请期待')
      // window.location.href = 'weixin://dl/business/?appid=wx2af2be9a3b47ff43&path=pages/web/huodong&env_version=release&query=type%3Dwqn_001'
    },
    showCodePop(type) {
      if (type === 'douyin') {
        window._paq && window._paq.push(['trackEvent', '官网', '点击', '抖音', 'mobile'])
        this.qrCodeImg = douyinPopImg
      } else {
        window._paq && window._paq.push(['trackEvent', '官网', '点击', '贴吧', 'mobile'])
        this.qrCodeImg = tiebaPopImg
      }
      this.codePopVisible = true
    },
    onClickGuide() {
      this.iosGuideVisible = true
      window._paq && window._paq.push(['trackEvent', '官网', '点击', 'ios指南', 'mobile'])
    }
  },
  mounted() {
    if (getParameterByName('jumpQQ') == '1') {
      window.location.href = this.qqGroupLink
    }
    this.ztmtag = getParameterByName('ztmtag') || ''
    // this.change()
  }
}
</script>

<style lang="stylus" scoped>
.btn {
  position: absolute;
  top 10rem
  left 50%
  transform: translate(-50%);

  img {
    width: 4.69rem;
    height: auto;
  }
}

.award-qrcode {
  position: absolute;
  width 1.91rem
  height auto
  left: .2rem;
  bottom: .4rem;
}

.phone {
  position: relative;
  margin 0 auto
  overflow-y auto
  width: 7.5rem;
  overflow-x: hidden;
  height: 14rem;
  z-index: auto;
  left: 0;
  top: 0;
  background-position: top center;
  background-repeat: no-repeat;
  background-image: url(../assets/bgb_m.jpg);
  background-size: 100% 100%
  font-size: .22rem;

  .logo {
    position absolute
    top 0.2rem
    left 0.06rem
    width 1.57rem
    height 0.66rem
    background url(../assets/logo-m.png) no-repeat center;
    background-size 100% 100%;
    animation slideInDown 0.5s ease-in-out
  }

  .link-head {
    position absolute
    top 0.3rem
    right 0.3rem
    width 1.04rem
    display flex
    justify-content space-between

    a {
      display block
      width .42rem
      height .42rem
      background url(../assets/link-head.png) no-repeat 0 0;
      background-size 1.04rem .42rem;

      &.tieba {
        background-position-x right
      }
    }
  }
  .slogan {
    background-repeat no-repeat
    background-size 100% 100%;
    position absolute
    top 6.6rem
    left 50%
    animation slideInDown 0.8s ease-in-out 0.2s
    &::after {
      content: '';
      position: absolute;
      inset: 12%;
      height: 87%;
      background: linear-gradient(40deg, rgba(255,255,255,0) 40%, rgba(191, 221, 223, 0.8), rgba(124,219,201,0) 60%);
      animation: shark-wrap 1.5s infinite;
      transform: translateX(-50%);
    }
  }
  &.stage_yuyue {
    .slogan {
      background-image url("../assets/slogan_yuyue_m.png")
      -webkit-mask: url('../assets/slogan_yuyue_m.png') 0 0/100%;
      width 6.37rem
      margin-left -3.185rem
      height 3.72rem
    }
  }
  &.stage_huaner {
    .slogan {
      background-image url("../assets/slogan_huaner_m.png")
      -webkit-mask: url('../assets/slogan_huaner_m.png') 0 0/100%;
      width 6.15rem
      margin-left -3.075rem
      height 3.30rem
      &::after {
        content: '';
        position: absolute;
        inset: 12%;
        height: 78%;
        background: linear-gradient(40deg, rgba(255,255,255,0) 40%, rgba(191, 221, 223, 0.8), rgba(124,219,201,0) 60%);
        animation: shark-wrap 1.5s infinite;
        transform: translateX(-50%);
      }
    }
  }
  &.stage_download {
    .slogan {
      background-image url("../assets/slogan_huaner_m.png")
      -webkit-mask: url('../assets/slogan_huaner_m.png') 0 0/100%;
      width 6.15rem
      margin-left -3.075rem
      height 3.30rem
      top 6rem
      &::after {
        content: '';
        position: absolute;
        inset: 12%;
        height: 78%;
        background: linear-gradient(40deg, rgba(255,255,255,0) 40%, rgba(191, 221, 223, 0.8), rgba(124,219,201,0) 60%);
        animation: shark-wrap 1.5s infinite;
        transform: translateX(-50%);
      }
    }
    .qrcode {
      transform translate(-50%, 0.2rem);
    }
  }
  .download-btn {
    position absolute
    top 8.8rem
    left 50%
    transform: translate(-50%);
    width 4.43rem
    height 1.04rem
    background url(../assets/download-btn_m.png) no-repeat center;
    background-size 100% 100%
    z-index 1
  }

  .guide-btn {
    position absolute
    top 10rem
    left 50%
    transform: translate(-50%);
    width 1.53rem
    height 0.33rem
    background url(../assets/guide-btn_m.png) no-repeat center;
    background-size 100% 100%
    z-index 2
  }

  .yuyue-btn {
    display block
    position: absolute;
    top 10.63rem
    left 50%
    transform: translate(-50%);
    background url(../assets/yuyue-btn_m.png) no-repeat center;
    background-size 100% 100%
    width 4.64rem
    height 1.15rem
  }
  .huaner-btn {
    display block
    position: absolute;
    top 10rem
    left 50%
    transform: translate(-50%);
    background url(../assets/huaner-btn.png) no-repeat center;
    background-size 100% 100%
    width 4.43rem
    height 1.47rem
  }
  .link-center {
    width 6.79rem
    height 2.55rem
    position absolute
    top 10.77rem
    left 50%
    transform: translate(-50%)
    background url("../assets/link-bg.png")
    background-size 100% 100%

    a {
      display block
    }

    .rule {
      position absolute
      left 2.82rem
      top .53rem
      width 1.49rem
      height .67rem
    }

    .version {
      position absolute
      left 2.82rem
      top 1.35rem
      width 1.49rem
      height .67rem
      background-image url("../assets/m-version.png")
      background-size 100% 100%
      animation fadeBtn 1s linear infinite alternate
    }

    .qr-code {
      width 1.3rem
      height 1.3rem
      position absolute
      left 1.24rem
      top 50%
      transform translateY(-50%)
    }

    .appt {
      position absolute
      left 2.24rem
      top .2rem
      width 2.37rem
      height .67rem
    }

    .qq, .douyin, .tieba {
      position absolute
      width .7rem
      height .67rem
      bottom .24rem
    }

    .qq {
      left 2.27rem
    }

    .douyin {
      left 3.08rem
    }

    .tieba {
      left 3.08rem
    }

    .pay {
      width 1.51rem
      height 1.51rem
      position absolute
      left 4.47rem
      top 50%
      transform translateY(-50%)
    }
  }

  .btns {
    position absolute
    bottom 0.76rem
    left 50%
    transform: translate(-50%)
    display flex;

    > a {
      background url('../assets/btns_m.png') no-repeat 0 0;
      background-size 4.66rem 0.96rem
      width 2.26rem
      height 0.96rem

      &:first-child {
        background-position-x 0
        margin-right .2rem
      }

      &:last-child {
        background-position-x right
      }
    }
  }
}

.qq-qrcode {
  position: absolute;
  right: .2rem;
  bottom: .4rem;
  width: 1.91rem;
  height: auto
}

.mini-app {
  position: absolute;
  left: 50%;
  bottom: .4rem;
  transform: translate(-50%);
  width: 1.91rem;
  height: auto
}

.logo img {
  width: 1.98rem;
  height: auto
}

.logo {
  position: absolute;
  top: .4rem;
  left: .4rem
}

.pay-center {
  display block
  background: url(../assets/pay-center_icon_m.png) no-repeat center;
  background-size: 100% 100%;
  position: absolute;
  width 1.92rem
  height .7rem
  right: .2rem;
  bottom: 2.7rem;
}

.qq-modal {
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  background rgba(0, 0, 0, .85)
  z-index 9999

  .modal-content {
    position absolute
    width 7.36rem
    height 4.97rem
    left 50%
    top 0
    transform translateX(-50%)
    background url("../assets/qq-modal-img.png")
    background-size 100% 100%

    .copy {
      width 2.2rem
      height .35rem
      position absolute
      bottom .78rem
      right .72rem
    }
  }
}

.qrcode-modal {
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  background rgba(0, 0, 0, .85)
  z-index 9999
  display flex
  flex-direction column
  align-items center
  justify-content center

  .content {
    .tips {
      margin 0 auto
      width 2.56rem
      height .3rem
      background url(../assets/save-img-tips.png) no-repeat center;
      background-size 100% 100%;
    }

    img {
      width 4.41rem
      height auto
      margin .3rem 0
    }

    .close {
      margin 0 auto
      width .56rem
      height .57rem
      background url(../assets/close.png) no-repeat center;
      background-size 100% 100%;
    }
  }

}
.bottom-tips {
  background url(../assets/bottom-tips.png) no-repeat center;
  background-size 100% 100%;
  width 7.5rem
  height .75rem
  position fixed;
  bottom 0
  z-index 1
  display: none
}
.popup-wrapper {
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  background rgba(0, 0, 0, .85)
  z-index 9999

  .popup {
    box-sizing border-box
    position absolute
    width 6.11rem
    height 7.82rem
    left 50%
    top 50%
    transform translate(-50%, -50%)
    background url("../assets/popup-bg.png")
    background-size 100% 100%
    padding 1.2rem .4rem .4rem

    .close {
      width .56rem
      height .57rem
      background url(../assets/close.png) no-repeat center;
      background-size 100% 100%;
      position absolute
      left 50%
      bottom -1rem
      transform translateX(-50%)
    }

    .popup-title {
      position absolute
      left 50%
      top .4rem
      transform translateX(-50%)
      height .44rem
      width auto
    }

    .ctx {
      width 100%
      height 100%
      overflow-y auto
      text-align: left;
      line-height: 1.8;
      .emphsis {
        background-color rgba(255,246,122,0.8)
      }
      h2 {
        font-size: 0.22rem;
        margin: 0.04rem 0;
      }
      a {
        cursor: pointer;
        color: #007aff;
        text-decoration: underline;
      }
    }
  }

  .rule-popup {
    .ctx {
      text-align left
      line-height 1.8
      a {
        cursor pointer
        color #007aff
        text-decoration underline
      }
      h2 {
        font-size: .22rem;
        margin .04rem 0
      }
    }
  }

  .version-popup {
    padding 1.2rem .3rem .3rem
  }

  .guide-popup {
    .ctx {
      img {
        width 100%
        height auto
      }
    }
  }
}
</style>
<style lang="stylus">
@keyframes fadeBtn {
  0% {
    opacity 1
  }
  100% {
    opacity 0
  }
}
@keyframes slideInDown {
  from {
    transform: translateY(-100%);
    visibility: visible;
  }

  to {
    transform: translateY(0);
  }
}

@keyframes shark-wrap {
  to {
    transform: translateX(100%);
  }
}
// .footer {
//   position relative !important
//   top 0 !important
//   margin 0 auto
//   width 8rem

//   #bottom .botps30 {
//     background-color transparent !important
//   }
// }
</style>